/*
 * @Author: 陈航
 * @Date: 2018-11-6 09:30:30
 * @Last Modified by: 陈航
 * @说明：邀请会员管理相关接口地址
 */

// 获取代理商邀请码
export const inviteGetInvitedCode = '/invite/get-invite-code'
// 获取邀请会员列表
export const inviteGetInvitedUserList = '/invite/get-invite-user-list'
// 获取邀请会员列表
export const inviteGetWxConfig = '/invite/get-wexin-sign-package'
// 获取邀请用户信息
export const inviterInfo = '/account/get-inviter-info'
// 邀请注册
export const invitedRegister = '/account/invited-register'
// 获取代理商图片
export const getInviteAgentImage = '/invite/get-agent-image'
// 记录网站访问量
export const recordTally = '/invite/tally'
// 获取拼图验证缺口与令牌
export const getPuzzleVerify = '/invite/get-puzzle-verify'
// 校验拼图位置
export const verifyPuzzle = '/invite/verify-puzzle'
